import { Col, Row } from "react-bootstrap"
import { getLandingPageUrl, getNewsPageUrl, getTeamPageUrl } from "../../../utils/urls"
import React, { useMemo, useState } from "react"
import moment from "moment"
import { Modal } from "antd"
import Image from "next/image"
import Link from "next/link"
import PredictionQuotes from "./PredictionQuotes"
import * as ImageConstants from "../../../constants/images"
import { LocalizedLanding } from "../../../types/landing"
import PredictionLandingQuotes from "@components/Predictions/PredictionLandingQuotes"

export const PredictionLandingRow = ({
  landing,
  showModalButton = true,
}: {
  landing: LocalizedLanding
  showModalButton?: boolean
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const match = landing.match!

  const pageTitle = useMemo(() => {
    return typeof window !== "undefined" && window.document.title
  }, [])
  const homeTeamUrl = getTeamPageUrl(match.homeTeam!.calciocomSlug!)
  const awayTeamUrl = getTeamPageUrl(match.awayTeam!.calciocomSlug!)

  return (
    <Col className={`prediction-match-row-cc odd`}>
      <Row lg={3} className="competition-banner-container">
        <div className="competition-banner">
          <span>{match.competition?.name}</span>
        </div>
      </Row>
      <Row className={"main-row"}>
        <Col lg={4} md={12} className={"team-info-col"}>
          <div className={"teams-container"}>
            {homeTeamUrl ? (
              <>
                <Link href={homeTeamUrl} passHref>
                  <a>
                    <div className={"team-image-div"}>
                      {match.homeTeam?.image?.path && (
                        <Image
                          blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                          placeholder="blur"
                          src={match.homeTeam.image.path}
                          alt={match.homeTeam.name}
                          width={32}
                          height={32}
                        />
                      )}
                    </div>
                  </a>
                </Link>
                <Link href={homeTeamUrl} passHref>
                  <a>
                    <div className={"team-name"}>{match.homeTeam?.name}</div>
                  </a>
                </Link>
              </>
            ) : (
              <>
                <div className={"team-image-div"}>
                  {match.homeTeam?.image?.path && (
                    <Image
                      blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                      placeholder="blur"
                      src={match.homeTeam.image.path}
                      alt={match.homeTeam.name}
                      width={32}
                      height={32}
                    />
                  )}
                </div>
                <div className={"team-name"}>{match.homeTeam?.name}</div>
              </>
            )}
          </div>
          <div className={"vs-div"}>{"VS"}</div>
          <div className={"teams-container"}>
            {awayTeamUrl ? (
              <>
                <Link href={awayTeamUrl} passHref>
                  <a>
                    <div className={"team-image-div"}>
                      {match.awayTeam?.image?.path && (
                        <Image
                          blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                          placeholder="blur"
                          src={match.awayTeam.image.path}
                          alt={match.awayTeam.name}
                          width={32}
                          height={32}
                        />
                      )}
                    </div>
                  </a>
                </Link>
                <Link href={awayTeamUrl} passHref>
                  <a>
                    <div className={"team-name"}>{match.awayTeam?.name}</div>
                  </a>
                </Link>
              </>
            ) : (
              <>
                <div className={"team-image-div"}>
                  {match.awayTeam?.image?.path && (
                    <Image
                      blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                      placeholder="blur"
                      src={match.awayTeam.image.path}
                      alt={match.awayTeam.name}
                      width={32}
                      height={32}
                    />
                  )}
                </div>
                <div className={"team-name"}>{match.awayTeam?.name}</div>
              </>
            )}
          </div>
        </Col>
        <PredictionLandingQuotes landing={landing} col={4} />
        <Col lg={{ span: 2 }} xs={{ span: 12 }} className="button-pronostico">
          <Link href={getLandingPageUrl(landing)} passHref legacyBehavior>
            <a style={{ textDecoration: "underline", textAlign: "center", minWidth: "200px" }}>Leggi il pronostico</a>
          </Link>
        </Col>
      </Row>
    </Col>
  )
}
